module.exports = __webpack_public_path__ + "daf943a37e4dee127085fe1f615bfda1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/i/i06.jpg
// module id = 610
// module chunks = 0